export default {"src":"/_next/static/media/olives.46e33926.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};